import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '../../../../features/dialog';
import { enqueueErrorSnack, enqueueSuccessSnack } from '../../../../features/snackbar';
import { addSubscriber } from '../../../../features/subscriber';
import SubscriberForm from '../SubscriberForm';
import { hasErrors } from '../../../../common';

const DIALOG_ID = "newSubscriber"
const DIALOG_WIDTH = "sm"

function NewSubscriberDialog() {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const project = useSelector(state => state.project.single);
    const show = !!useSelector((state) => state.dialog[DIALOG_ID])
    const [errors, setErrors] = useState({});
    const [form, setForm] = useState({});

    const save = e => {
        e && e.preventDefault() && e.stopPropagation();
        const errors = {}
        if(hasErrors(errors)){
            return;
        }

        setLoading(true);
        dispatch(addSubscriber({
            project,
            subscriber: form
        }))
        .then(r => {
            r.payload.id && dispatch(closeDialog(DIALOG_ID));
            r.payload.id && dispatch(enqueueSuccessSnack("Subscriber saved"))    
        })
        .catch(e => {
            dispatch(enqueueErrorSnack("Error: " + e))    
        })
        .finally(() => {
            setLoading(false);
        })
    }

    const onClose = () => {
        dispatch(closeDialog(DIALOG_ID));
    }
    

    useEffect(() => {
        setForm({});
    }, [show])

    return <Dialog
        open={!!show}
        onClose={onClose}
        fullWidth
        maxWidth={DIALOG_WIDTH}
        
    >
        <form onSubmit={save}>
            <DialogTitle>
                Add subscriber
            </DialogTitle>
            <DialogContent dividers={false}>

                <Box pr={3}>
                    <SubscriberForm form={form} onChange={setForm} errors={errors} />
                </Box> 
                
            </DialogContent>
            <DialogActions>
                {loading && <LinearProgress />}
                {!loading && <Box sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Button sx={{marginRight: 2}} onClick={onClose} >Cancel</Button>
                    <Button variant="contained" color="secondary" type="submit">Add Subscriber</Button>
                </Box>}
            </DialogActions>
        </form>
    </Dialog>
}

export default NewSubscriberDialog;